import {
  SELECT_CITY_FAILURE,
  SELECT_CITY_REQUEST,
  SELECT_CITY_SUCCESS,
  SELECT_COUNTRY_AIRPORT_FAILURE,
  SELECT_COUNTRY_AIRPORT_REQUEST,
  SELECT_COUNTRY_AIRPORT_SUCCESS,
  SELECT_COUNTRY_FAILURE,
  SELECT_COUNTRY_REQUEST,
  SELECT_COUNTRY_SUCCESS,
  SELECT_STATE_AIRPORT_FAILURE,
  SELECT_STATE_AIRPORT_REQUEST,
  SELECT_STATE_AIRPORT_SUCCESS,
  SELECT_STATE_FAILURE,
  SELECT_STATE_REQUEST,
  SELECT_STATE_SUCCESS,
} from "./selectorType";

const initialState = {
  country: {
    loading: false,
    data: [],
    error: null,
    success: null,
  },
  state: {
    loading: false,
    data: [],
    error: null,
    success: null,
  },
  city: {
    loading: false,
    data: [],
    errro: null,
    success: null,
  },
};

const selectorReducer = (state = initialState, action) => {
  switch (action.type) {
    // COUNTRY Actions
    case SELECT_COUNTRY_REQUEST:
      return {
        ...state,
        country: {
          ...state.country,
          loading: true,
          error: null,
          success: null,
        },
      };
    case SELECT_COUNTRY_SUCCESS:
      return {
        ...state,
        country: {
          ...state.country,
          loading: false,
          data: action.payload,
          error: null,
          success: action.payload?.message,
        },
      };
    case SELECT_COUNTRY_FAILURE:
      return {
        ...state,
        country: {
          ...state.country,
          loading: false,
          data: [],
          error: action.payload,
          success: null,
        },
      };
    // STATE Actions
    case SELECT_STATE_REQUEST:
      return {
        ...state,
        state: { ...state.state, loading: true, error: null, success: null },
      };
    case SELECT_STATE_SUCCESS:
      return {
        ...state,
        state: {
          ...state.state,
          loading: false,
          data: action.payload,
          error: null,
          success: action.payload?.message,
        },
      };
    case SELECT_STATE_FAILURE:
      return {
        ...state,
        state: {
          ...state.state,
          loading: false,
          data: [],
          error: action.payload,
          success: null,
        },
      };
    //cityAction
    case SELECT_CITY_REQUEST:
      return {
        ...state,
        city: { ...state.city, loading: true, error: null, success: null },
      };
    case SELECT_CITY_SUCCESS:
      return {
        ...state,
        city: {
          ...state.city,
          loading: false,
          data: action.payload,
          error: null,
          success: action.payload?.message,
        },
      };

    case SELECT_CITY_FAILURE:
      return {
        ...state,
        city: {
          ...state.city,
          loading: false,
          data: [],
          error: action.payload,
          success: null,
        },
      };

    // COUNTRY Airport Actions
    case SELECT_COUNTRY_AIRPORT_REQUEST:
      return {
        ...state,
        country: {
          ...state.country,
          loading: true,
          error: null,
          success: null,
        },
      };
    case SELECT_COUNTRY_AIRPORT_SUCCESS:
      return {
        ...state,
        country: {
          ...state.country,
          loading: false,
          data: action.payload,
          error: null,
          success: action.payload?.message,
        },
      };
    case SELECT_COUNTRY_AIRPORT_FAILURE:
      return {
        ...state,
        country: {
          ...state.country,
          loading: false,
          data: [],
          error: action.payload,
          success: null,
        },
      };
    // stateAirport
    case SELECT_STATE_AIRPORT_REQUEST:
      return {
        ...state,
        state: { ...state.state, loading: true, error: null, success: null },
      };
    case SELECT_STATE_AIRPORT_SUCCESS:
      return {
        ...state,
        state: {
          ...state.state,
          loading: false,
          data: action.payload,
          error: null,
          success: action.payload?.message,
        },
      };
    case SELECT_STATE_AIRPORT_FAILURE:
      return {
        ...state,
        state: {
          ...state.state,
          loading: false,
          data: [],
          error: action.payload,
          success: null,
        },
      };
    default:
      return state;
  }
};

export default selectorReducer;
